<template>
  <!--  资质审核详情-->
  <div class="advanced-form">

    <a-form layout="vertical">
      <div class="card">
        <div class="card-head">
          <h3>门店信息</h3>
        </div>
        <div class="card-body">
          <a-row
            type="flex"
            justify="space-between"
            style="margin-bottom: 50px"
          >
            <div class="card-box">
              <div style="margin-bottom: 10px">门店名称:</div>
              <div>{{data.shopName}}</div>
            </div>
            <div class="card-box">
              <div style="margin-bottom: 10px">网点类型:</div>
              <div>{{data.branchTypeDesc}}</div>
            </div>
            <div class="card-box">
            </div>
          </a-row>
          <a-row
            type="flex"
            justify="space-between"
            style="margin-bottom: 50px"
          >
            <div class="card-box">
              <div style="margin-bottom: 10px">所在地区:</div>
              <div>{{data.area}}</div>
            </div>
            <div class="card-box">
              <div style="margin-bottom: 10px">详细地址:</div>
              <div>{{data.address}}</div>
            </div>
            <div class="card-box">
              <div style="margin-bottom: 10px">所属商圈:</div>
              <div>{{data.bizAreaName}}</div>
            </div>
          </a-row>
          <a-row
            type="flex"
            style="margin-bottom: 50px"
            justify="space-between"
          >
            <div class="card-box">
              <div style="margin-bottom: 10px">营业电话:</div>
              <div>{{data.telephone}}</div>
            </div>
            <div class="card-box">
              <div style="margin-bottom: 10px">门头照片:</div>
              <div>
                <template v-for=" (item,i) in data.shopImage" >
                  <div class="img-box" :key = 'i'>
                    <span >
                      <img :src="item.fileUrl" alt="" @click="openImg(item.fileUrl)" />
                    </span>
                  </div>
                </template>
              </div>

            </div>
            <div class="card-box">
              <div style="margin-bottom: 10px">门店位置:</div>
              <div class="amap-box" id="container" @click="showMap"></div>
            </div>
          </a-row>
        </div>
      </div>
    </a-form>
    <a-modal
      title="查看"
      :visible="visible"
      @cancel="visible = false"
      :footer="null"
      :maskClosable="true"
      :keyboard="true"
      destroyOnClose
      centered
      :width="800"
    >
      <div class="model-img"><img :src="img" alt="" /></div>
    </a-modal>

    <div class="card">
      <div class="card-head">
        <h3>基本资质</h3>
      </div>
      <div class="card-body">
        <!--删除列表时使用的是rowKey的id-->
        <a-row type="flex" justify="space-between" style="margin-bottom: 50px" v-if="data.branchType == 1">
          <div class="card-box">
            <div style="margin-bottom: 10px">注册号:</div>
            <div>{{data.registerNo}}</div>
          </div>
          <div class="card-box">
            <div style="margin-bottom: 10px">执照名称:</div>
            <div>{{data.companyName}}</div>
          </div>
          <div class="card-box">
            <div style="margin-bottom: 10px">法人名字:</div>
            <div>{{data.legalPerson}}</div>
          </div>
        </a-row>
        <a-row type="flex" justify="space-between" style="margin-bottom: 50px" v-if="data.branchType == 1">
          <div class="card-box">
            <div style="margin-bottom: 10px">营业执照备案:</div>
            <div class="img-box">
              <img :src="data.licenseImage" alt="" @click="openImg(data.licenseImage)" />
            </div>
          </div>
        </a-row>
        <a-row type="flex" justify="space-between" style="margin-bottom: 50px">
          <div class="card-box">
            <div style="margin-bottom: 10px">{{data.branchType ==1? '法人':''}}手机号:</div>
            <div>{{data.mobile}}</div>
          </div>
          <div class="card-box">
            <div style="margin-bottom: 10px">身份证号:</div>
            <div>{{data.idcardNumber}}</div>
          </div>
          <div class="card-box">
            <div style="margin-bottom: 10px">证件名字:</div>
            <div>{{data.name}}</div>
          </div>
        </a-row>
        <a-row type="flex" style="margin-bottom: 50px">
          <div class="card-box">
            <div style="margin-bottom: 10px">身份证正面:</div>
            <div class="img-box">
              <img :src="data.idcardFaceImage" alt="" @click="openImg(data.idcardFaceImage)" />
            </div>
          </div>
          <div class="card-box">
            <div style="margin-bottom: 10px">身份证反面:</div>
            <div class="img-box">
              <img :src="data.idcardBackImage" alt="" @click="openImg(data.idcardBackImage)" />
            </div>
          </div>
        </a-row>
      </div>
    </div>
    <div v-hasPermi="['community:housekeepShopApply:edit']">
      <approval-model :id = 'id' @pass = "pass" @reject = "reject" v-if="showBanner"></approval-model>
    </div>
    <map-model ref='mapModel'></map-model>
  </div>
</template>

<script>
import ApprovalModel from './approvalModel.vue';
import { empty } from 'ant-design-vue-admin-x';
import mapModel from '../component/mapModel.vue';
export default {
  components: {ApprovalModel, mapModel},
  data () {
    return {
      showBanner: false,
      id: undefined,
      img: undefined,
      position: '',
      visible: false,
      columns: [
        {
          title: '资质名称',
          dataIndex: 'title',
          align: '',
          width: '200'
        },
        {
          title: '有效期',
          dataIndex: 'expireTime',
          align: '',
          width: '200'
        },
        {
          title: '资质证书',
          dataIndex: 'fileImage',
          align: '',
          width: '200',
          scopedSlots: { customRender: 'img' }
        },
        {
          title: '类型',
          dataIndex: 'isRequireDesc',
          align: '',
          width: '200'
        }
      ],
      tableData: [],
      data: []
    };
  },
  beforeCreate () {
    this.form = this.$form.createForm(this);
  },
  beforeRouteEnter (to, from, next) {
    next();
    setTimeout(() => {
      document.getElementsByClassName('layout-nav')[0].style['z-index'] = '161';
      document.getElementsByClassName('layout-aside')[0].style['z-index'] = '200';
      document.getElementsByClassName('layout-content')[0].style.backgroundColor = 'transparent';
      document.getElementsByClassName('layout-content')[0].style.padding = '0px';
    }, 0);
  },
  beforeRouteLeave (to, from, next) {
    document.getElementsByClassName('layout-content')[0].style.backgroundColor =
      '#fff';
    document.getElementsByClassName('layout-content')[0].style.padding = '16px';
    next();
  },
  created () {
    if (this.$route.query.id) {
      this.getDetail(this.$route.query.id);
      this.id = this.$route.query.id;
    }
    if (this.$route.query.status == 1) {
      this.showBanner = true;
    } else {
      this.showBanner = false;
    }
  },
  methods: {
    showMap () {
      this.$refs.mapModel.show(this.data.mapLng, this.data.mapLat);
    },
    pass (val) {
      this.toExamine(3, val);
    },
    reject (val) {
      this.toExamine(2, val);
    },
    toExamine (type, modalValue) {
      //  1待审核2已驳回3已通过
      this.$put({
        url: '/housekeep/shopApply/' + this.id,
        params: {
          checkStatus: type,
          qfRejectRemark: modalValue // 审核备注
        }
      }).then((res) => {
        this.$message[type == 3 ? 'success' : 'error'](type == 3 ? '审核通过' : '审核已驳回');
        empty.$emit('update_qualification');
        this.$router.go(-1);
      });
    },
    show () {},
    openImg (img) {
      this.visible = true;
      this.img = img || '';
    },
    getDetail (id) {
      this.$get({
        url: '/housekeep/shopApply/' + id,
        params: {}
      }).then(({data}) => {
        this.data = data;
        this.initAMap();
      });
    },
    initAMap () {
      this.$nextTick(() => {
        AMapUI.loadUI(['misc/PositionPicker'], (PositionPicker) => {
          this.map = new AMap.Map('container', {
            resizeEnable: true,
            scrollWheel: true
          });
          this.map.setZoomAndCenter(15, [this.data.mapLng, this.data.mapLat]);

          let marker = new AMap.Marker({
            position: new AMap.LngLat(this.data.mapLng, this.data.mapLat),
            anchor: 'bottom-center',
            offset: new AMap.Pixel(0, 0)
          });
          this.map.add(marker);
        });
      });
    }
  }
};
</script>

<style scoped>
.amap-box {
  width: 220px;
  height: 100px;
}
.img-box {
  height: 100px;
  display: inline-block;
  margin: 0 10px 10px 0;
}
.img-box img {
  width: 100px;
  height: 100%;
  object-fit: contain;
  background: #ededed;
}
.model-img img {
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 800px;
  padding: 5px;
  margin:0 auto;
  display: block;
}
.card-box{
  font-size: 14px;
  width: 33.33333333%;
  word-break: break-all;
}
.card-box>div:nth-child(2){padding-left:8px;margin-top:18px;}

</style>
